import { ErrorService, ParseService } from '../services';
import { User, UserNotification } from '../models';
import { BaseModelService } from './base/base-modelservice';

export class UserNotificationService extends BaseModelService<UserNotification> {

    constructor(errorService: ErrorService, parseService: ParseService) {
        super(errorService, parseService, UserNotification);
    }

    public getUnread(user: User): Promise<UserNotification[]> {
        return this.createUnreadQuery(user).find();
    }

    public getAll(user: User): Promise<UserNotification[]> {
        const query = this.createQuery(['user']);
        query.equalTo('user', user);
        return query.findAll().then(notifications =>
            notifications.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime()));
    }

    public subUnread(user: User) {
        return this.parseService.subscribe<UserNotification>(this.createUnreadQuery(user));
    }

    private createUnreadQuery(user: User) {
        const query = this.createQuery(['user']);
        query.equalTo('user', user);
        query.doesNotExist('readAt');
        query.descending('createdAt' as any);
        return query;
    }
}
